import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import FivaLayout from "../Layout/FivaLayout";
import HeadComponent from "../components/HeadComponent/HeadComponent";
import PrivacyPolicy from "../components/PrivacyPolicy/PrivacyPolicy";
var Privacy = function() {
    var headerProps = {
        title: "Pol\xedtica de privacidad",
        keywords: "Asesor\xeda energ\xe9tica, Consultor\xeda energ\xe9tica, Optimizaci\xf3n energ\xe9tica, \n        Asesoramiento el\xe9ctrico, Renovables, energ\xedas Renovables, eficiencia energ\xe9ticas,\n        consultor\xeda de software, asesoramiento de software, Comparativa de Tarifas, Comparativa de Energ\xe9tica,\n        Comparativa de luz, Comparativa de luz y gas, Comparativa de gas",
        content: "Pol\xedtica de privacidad de Fiva, en Fiva nos preocupa la privacidad de nuestros clientes"
    };
    return /*#__PURE__*/ _jsxs(FivaLayout, {
        blue: false,
        children: [
            /*#__PURE__*/ _jsx(HeadComponent, _object_spread({}, headerProps)),
            /*#__PURE__*/ _jsx(PrivacyPolicy, {})
        ]
    });
};
export default Privacy;
